<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-container fluid>
       <v-card-title :class="titleClasses">{{ $t('subOrder.DeliveryConfirmation') }}</v-card-title>
        <v-card-text v-if="orderType === 'click_and_reserve'">{{ $t('components.customerDeliveryDialog.orderUnpaid') }}</v-card-text>
        <span v-else-if="hasPickupCode">
          <v-card-text >{{ $t('components.customerDeliveryDialog.typePickupCode') }}</v-card-text>
          <v-text-field type="number" v-model="pickupCode" :label="$t('components.customerDeliveryDialog.pickupCode')">
          </v-text-field>
        </span>
      </v-container>
      <v-card-actions class="pa-0">
        <v-btn color="secondary" tile block @click="save()" :disabled="hasPickupCode && !pickupCode">{{ $t('subOrder.confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: "CustomerDeliveryDialog",
    props: {
        value: {
           type: Boolean
        },
        orderType: {
          type: String
        },
        hasPickupCode: {
          type: Boolean
        },
    },
    data() {
      return {
        pickupCode: ""
      }
    },
    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        },
      isMobile() {
        return this.$vuetify.breakpoint.width < 425
      },
      titleClasses() {
        return {
          'dialog-title': true,
          'dialog-title--mobile': this.isMobile
        }
      }
    },
    methods: {
        save: function(){
            this.$emit("validateCustomerDelivery", this.pickupCode)
        },
    }
}
</script>

<style scoped>
.dialog-title {
  justify-content: center;
  word-break: break-word;
  white-space: normal;
}

.dialog-title--mobile {
  font-size: 1.1rem;
}
</style>